<template>
<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 36 36" style="enable-background:new 0 0 36 36;" xml:space="preserve">
<path d="M35,0H1C0.448,0,0,0.447,0,1v34c0,0.553,0.448,1,1,1h34c0.552,0,1-0.447,1-1V1C36,0.447,35.552,0,35,0z M34,34H2V2h32V34z"
		:style="{
			width: width,
			fill: colour
		}"
	/>
</svg>

</template>

<script>
import Mixin from './Mixin';

export default {
  mixins: [Mixin],
};
</script>
